// extracted by mini-css-extract-plugin
export default {"outer_container":"PageContainer_outer_container__qBCM2","container":"PageContainer_container__olKyE"};